import angular from 'angular';

import DateGrouping from './date';

class FactDateishGrouping extends DateGrouping {
  constructor() {
    super();

    this.key = 'factDateish';
    this.displayName = 'Key Date';

    this.columnsByGroup = this.setColumns([
      'legalIssues',
      'title',
      'content',
      'sources',
      'tags',
      'contributors',
      'creationDate'
    ]);

    this.reverseSortable = true;
    this.sortDirectionText = {
      true: {
        text: '9 - 1',
        icon: 'glyphicon-sort-by-order-alt'
      },
      false: {
        text: '1 - 9',
        icon: 'glyphicon-sort-by-order'
      }
    };
  }

  getDisplayText(dateish) {
    return (dateish && dateish.displayName) ||
      '<span class="text-muted">No Date</span>';
  };

  getMemoText(dateish) {
    return dateish && dateish.displayName
  };

  getSortingValue(dateish) {
    return dateish ? dateish.sortableString : '';
  };

  getItemsByFact(fact) {
    var items = [];
    var d = fact[this.key];
    if (d) {
      // matches 'id' created by addDateToDates in buildTree below
      items.push(d.sortableString);
    } else {
      items.push('ungrouped');
    }
    return items;
  };

  getDocDisplayText(value) {
    return this.getDisplayText(value)
  };

  getHeaderDisplayName(value) {
    return value.headerDisplayName || this.ungroupedName;
  };
}

export default angular.module('groupings.fact-dateish-grouping', [])
  .service('FactDateishGrouping', FactDateishGrouping)
  .name;



// WEBPACK FOOTER //
// ./project/groupings/fact-dateish.js